import { Input, Label, ModalBody } from 'reactstrap'

const ForgotMembershipModalBody = ({ email, hasSubmitted, onChange, success }) => {
  const getContent = () => {
    if (!hasSubmitted) return (
      <>
        <p className="text-muted mb-3">
          We'll send your active membership details to your email. Please provide your email address below.
        </p>

        <Label for="membership-code">Membership Code</Label>

        <Input className="text-gray-600 mb-3" id="membership-code" name="membership-code" onChange={onChange}
              placeholder="Enter Membership code" type="text" value={email} />
      </>
    )

    if (success) return (
      <>
        <p>Details sent to your email</p>
      </>
    )

    return (
      <>
        <p>Membership Required</p>
      </>
    )
  }

  return (
    <ModalBody>
      {getContent()}
    </ModalBody>
  )
}

export default ForgotMembershipModalBody
